import { render, staticRenderFns } from "./ShippingRequestComponent.vue?vue&type=template&id=6ec2be61&scoped=true&"
import script from "./ShippingRequestComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingRequestComponent.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRequestComponent.vue?vue&type=style&index=0&id=6ec2be61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2be61",
  null
  
)

export default component.exports